module.exports = __webpack_public_path__ + "img/wallet.5ba6eed1.svg";